module.exports = __webpack_public_path__ + "img/lingnanyingxiangyuan.ac451609.png";